import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import styles from './index.module.scss';

const firstXDaysOptions = [
  { count: 29, unit: 'days', text: 'First 30 days' },
  { count: 89, unit: 'days', text: 'First 90 days' },
];

const standardOptions = [
  { count: 6, unit: 'days', text: 'Last 7 days' },
  { count: 13, unit: 'days', text: 'Last 14 days' },
  { count: 29, unit: 'days', text: 'Last 30 days' },
  { count: 89, unit: 'days', text: 'Last 90 days' },
];

export class Dropdown extends Component {
  static propTypes = {
    onDatesChange: PropTypes.func.isRequired,
    onIsCustomDate: PropTypes.func.isRequired,
    endDate: PropTypes.string.isRequired,
    showFirstDaysOptions: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    showFirstDaysOptions: false,
  };

  get allTimeOption() {
    const labelText = 'All time';
    const dateRange = {
      startDate: moment('2015-05-01'),
      endDate: moment(this.props.endDate),
      label: labelText,
    };
    return this.generateOption(labelText, dateRange);
  }

  get lastCalendarMonthOption() {
    const labelText = 'Last calendar month';
    const dateRange = {
      startDate: moment()
        .subtract(1, 'months')
        .startOf('month'),
      endDate: moment()
        .subtract(1, 'months')
        .endOf('month'),
      label: labelText,
    };
    return this.generateOption(labelText, dateRange);
  }

  get options() {
    let dropdownOptions;

    if (this.props.showFirstDaysOptions) {
      dropdownOptions = [...standardOptions, ...firstXDaysOptions];
    } else {
      dropdownOptions = standardOptions;
    }

    const options = dropdownOptions.map(({ count, unit, text }) => {
      const dateRange = {
        startDate: moment(this.props.endDate).subtract(count, unit),
        endDate: moment(this.props.endDate),
        label: text,
      };

      return this.generateOption(text, dateRange);
    });

    return [...options, this.lastCalendarMonthOption, this.allTimeOption];
  }

  generateOption(text, dateRange) {
    const Row = 'li';
    return (
      <Row className={styles.row} onClick={() => this.props.onDatesChange(dateRange)} key={text}>
        <FormattedMessage
          id={`dropdown.${text
            .split(' ')
            .join('-')
            .toLowerCase()}`}
          description={`date range dropdown option for ${text.toLowerCase()}`}
          defaultMessage={`${text}`}
        />
      </Row>
    );
  }

  render() {
    const { onIsCustomDate } = this.props;
    const Row = 'li';
    return (
      <ul className={styles.parent} data-qa="date-options-list">
        {this.options}
        <Row className={classNames(styles.row, styles.rowCustom)} onClick={onIsCustomDate}>
          <FormattedMessage id="dropdown.choose" defaultMessage="Choose date range" />
        </Row>
      </ul>
    );
  }
}
